import React from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';
import VerbText from '../../../../../shared/components/VerbText';

export default function HeaderContentCount({
    contentLoading,
    allCollections = [],
    currentCollection,
    userCollectionContent // accommodates user collections not updated to current collection content
}) {
    let defaultMessage;
    let messageId;
    let length;
    if (currentCollection) {
        length = userCollectionContent ? userCollectionContent.length : (currentCollection.contentIds || []).length;
        defaultMessage = length === 1 ? 'Activity' : 'Activities';
        messageId = length === 1 ? 'HEADING_ACTIVITY' : 'HEADING_ACTIVITIES';
    } else {
        ({ length = 0 } = allCollections);
        defaultMessage = length === 1 ? 'Collection' : 'Collections';
        messageId = length === 1 ? 'HEADING_COLLECTION' : 'HEADING_COLLECTIONS';
    }

    const isMobile = window.innerWidth < 768;
    return (
        <div className={'header-activities-count col-12'}>
            <i className={`${isMobile ? 'fal' : 'fas' } fa-book my-auto`} />
            <span className={cns({ loading: contentLoading })}>
                {contentLoading ? null : `${length} `}
                {!contentLoading && <VerbText defaultMessage={defaultMessage} messageId={messageId} />}
            </span>
        </div>
    );
}

HeaderContentCount.propTypes = {
    contentLoading: PropTypes.bool,
    allCollections: PropTypes.array,
    currentCollection: PropTypes.object,
    userCollectionContent: PropTypes.array
};
